<p-dialog class="minWidth80" [(visible)]="visibility" [responsive]="true" [modal]="true" (onHide)="closeDialog()">
    <p-header>
        <h2>
            {{ wizardMode ? ('common.assignOf'|hisUi:('fs.res.researchInfrastructure.ResearchInfrastructure.researchInfrastructureEmployment'|hisUi)) : ('common.editOf'|hisUi:('fs.res.researchInfrastructure.ResearchInfrastructure.researchInfrastructureEmployment'|hisUi)) }}
        </h2>
    </p-header>

    <ng-container *ngIf="wizardMode; else editAdditinalData">
        <p-steps #steps class="wizardSteps centeringContainer" [model]="menuItems" [activeIndex]="activeIndex"></p-steps>
        
        <ng-container *ngIf="activeIndex === 0">
            <res-research-infrastructure-search-person-employment
                [researchInfrastructureEmployment]="researchInfrastructureEmployment"
                (submitResearchInfrastructureEmployment)="submitResearchInfrastructureEmployment()">
            </res-research-infrastructure-search-person-employment>    
        </ng-container>
        <ng-container *ngIf="activeIndex === 1">
            <res-research-infrastructure-edit-employment-additional-data
                [researchInfrastructureEmployment]="researchInfrastructureEmployment">
            </res-research-infrastructure-edit-employment-additional-data>
        </ng-container>
    
        <p-footer>
            <button *ngIf="activeIndex === 1" (click)="activeIndex = 0">
                <span>{{'common.back'|hisUi}}</span>
            </button>
            <button *ngIf="activeIndex === 1" (click)="saveEmployment()">
                <span>{{'common.apply'|hisUi}}</span>
            </button>
        </p-footer>
    </ng-container>
    
    <ng-template #editAdditinalData>
       <res-research-infrastructure-edit-employment-additional-data
            [researchInfrastructureEmployment]="researchInfrastructureEmployment">
        </res-research-infrastructure-edit-employment-additional-data>
        
        <p-footer>
            <button (click)="saveEmployment()">
                <span>{{'common.apply'|hisUi}}</span>
            </button>
            <button (click)="closeDialog()">
                <span>{{'common.cancel'|hisUi}}</span>
            </button>
        </p-footer>
        
    </ng-template>

<p-dialog>